import { supabase } from "@/lib/supabaseClient";

export type CompanyShellCapabilities = {
  company_id: string;
  company_name: string;
  requires_dual_sign_off: boolean;
  is_owner: boolean;
  is_company_creator: boolean;
  is_employee_in_company: boolean;
  is_management_employee: boolean;
  can_view_my_workspace: boolean;
  can_view_my_payslips: boolean;
  can_view_my_timesheets: boolean;
  can_view_my_disputes: boolean;
  can_submit_my_disputes: boolean;
  can_report_my_absences: boolean;
  can_request_my_leave: boolean;
  can_submit_payroll: boolean;
  can_issue_payroll: boolean;
  can_view_company_overview: boolean;
  can_invite_employees: boolean;
  can_manage_employees: boolean;
  can_manage_time_away_opening_balances: boolean;
  can_manage_company_settings: boolean;
  can_manage_payroll_periods: boolean;
  can_manage_company_rule_proposals: boolean;
  can_grant_company_rule_proposal_authority: boolean;
  can_access_company_shell: boolean;
};

export async function getCompanyShellCapabilities(
  companyId: string
): Promise<CompanyShellCapabilities | null> {
  const { data, error } = await supabase.rpc("get_company_shell_capabilities", {
    p_company_id: companyId,
  });

  if (error) {
    throw error;
  }

  if (!Array.isArray(data) || data.length === 0) {
    return null;
  }

  return data[0] as CompanyShellCapabilities;
}